import { Link } from 'react-router-dom';
import * as style from '../../utils/general_style.js';
import * as links from '../../utils/general_links.js';

function CTAButton({ label='Devis gratuit', route=links.ROUTES.devis }) {
    const backgroundStyle = {
        width: '280px',
        height: '40px',
        borderRadius: '20px',
        backgroundColor: style.COLORS.primary,
        color: style.COLORS.white,
    };

	return (
        <div style={backgroundStyle}>
            <Link to={ route }>
				<p>{ label }</p>
			</Link>
		</div>
	);
};

export default CTAButton;